import { MouseEvent } from 'react';
import { Icon } from '@frontend/icons';
import { NakedButton, Text } from '@frontend/design-system';
import { closeIconStyles, containerStyles, countBadgeStyles } from './selection-chip.styles';

type Props = {
  active: boolean;
  count?: number;
  disabled?: boolean;
  label: string;
  size?: 'small' | 'large';
  onClick?: () => void;
  onRemove?: (event: MouseEvent<HTMLButtonElement>) => void;
};

// TODO: This needs to be moved to DS Chip component with variants - small and large
export const SelectionChip = ({ active, count, disabled = false, label, onClick, onRemove }: Props) => {
  return (
    <NakedButton css={containerStyles(active)} onClick={() => onClick?.()} disabled={disabled}>
      {Number(count) > 0 && (
        <div css={countBadgeStyles}>
          <Text size='small' weight='bold' color='white'>
            {count}
          </Text>
        </div>
      )}
      <Text size={'small'} color={'default'}>
        {label}
      </Text>
      {active && onRemove && (
        <NakedButton css={closeIconStyles} onClick={(event) => onRemove?.(event)}>
          <Icon name='x-tiny' color={'default'} />
        </NakedButton>
      )}
    </NakedButton>
  );
};
